module.exports = __webpack_public_path__ + "img/S1051438.0d00bc6a.jpg";